import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { entityTypeDefaults, EntityTypeMeta } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_SHOAL_FLOOR_DEFAULT, ELEVATION_WATER_LEVEL_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Shoal,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_SHOAL_FLOOR_DEFAULT,
  water_e: ELEVATION_WATER_LEVEL_DEFAULT,
} as const

export const ShoalEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Shoal),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type ShoalEntity = InferOutput<typeof ShoalEntitySchema>

/**
 * Shallow area in a body of water, often a sandbank or bar that makes the water shallow.
 * Also includes beach.
 */
export const ShoalEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Shoal,
  dname: 'Shoal',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createShoalEntity(
  id: number,
  x: number,
  y: number,
  // shoal: ShoalKind
): ShoalEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
    // shoal,
  }
}
